export const welcomePhase = "Welcome to Conceive";
export const yourFertilityJourneyPhase = "Your journey";
export const logisticsPhase = "Logistics";
export const emptyPhase = "";
